
/**
 * 추가 메타데이터
 */
export type GetStreamingInfo200MediaInfoMetadata = { [key: string]: unknown };
